var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForbidden = function SvgForbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 320 219"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Forbidden_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#E97537",
    strokeMiterlimit: 10,
    d: "m58.962 73.608 3.25 12.127s7.433 2.954 10.942-2.933l-3.528-13.267s-3.24 6.47-10.664 4.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3391B9",
    d: "M58.683 83.376S44.408 91.301 41.7 93.102s-7.193 4.424-7.447 16.791-.425 36.996-.425 36.996 2.838 17.257 18.773 8.903l6.248-3.282 53.884-14.438.89-35.901 1.64-1.864-12.638-19.26s-1.192-3.78-10.495-3.247a165 165 0 0 0-16.968 1.871s-6.347 4.915-16.478 3.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#004765",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.31,
    d: "m53.716 103.424 4.891 27.569"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.311,
    d: "m92.878 92.577 19.861 33.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97537",
    d: "m62.18 73.91 9.135 1.87-1.68-6.267s-1.886 4.159-7.455 4.397"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F666D",
    d: "m79.936 124.603 10.206 14.196-4.512 1.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M227.85 77.88c48.36-3 64.33-13.22 61.94-32-.58-3.68.88-6.08-1-3.34-16.15 23.05-64.73 16.34-98.23 18.33zM96.33 154l.07 15.41c-8.72 1.4-22.56 4-28.52 5.65-17.21 4.68-26.35 8.68-27.2 18.05.06-9.61 0-11.71 0-15.61 0-17.5 34.39-22.06 55.65-23.5M94.42 196.491l-33.19.145.033 7.51 33.19-.145z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.21 191.67c2.78-3.47 9.15-5.92 16.57-6s13.8 2.36 16.62 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0076A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m155.32 165.95-26.81 19.55-6.99-9.57-12.18-22.41 21.38-15.6 17.46 18.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "m150.894 159.903-26.817 19.555 4.425 6.068 26.817-19.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121.16 175.43c.22-4.45 4-10.16 9.94-14.53s12.57-6.18 16.87-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0076A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M121.16 175.43c.22-4.45 4-10.16 9.94-14.53s12.57-6.18 16.87-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ED07F",
    d: "M115.71 149.85 108.5 140l9.58-7 7.22 9.9c1.91 2.61-7.66 9.59-9.59 6.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ED07F",
    stroke: "#0076A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m105.848 97.352 11.412-6.889-14.347-23.765-11.412 6.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0076A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m93.65 84.4 17.85-10.78-5-8.36a11.094 11.094 0 0 0-15.23-3.76l-5.13 3.1s-3.22 1.95 1.11 9.13zm9.97 14.01 16.88-10.16 10 16.6c3.67 6.08 4.72 13.66-2.74 17-3 1.35-7.13-.38-6-5.1 1-4.27.45-9.38-3.27-8.73 0 0 4.15 11.85-2.49 13.24-3.78.79-5-3.42-5.7-5.24-.93-2.56-3.44-8.35-.91-10.87-1.78.59-4.01-3.93-5.77-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.5 108s-2.35-6.54-9.1-2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0076A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M118.5 108s-2.35-6.54-9.1-2.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6DEE3",
    d: "M267.81 4a3 3 0 0 0-3-3H80.5a3 3 0 0 0-3 3v197.56a3 3 0 0 0 3 3h184.31a3 3 0 0 0 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C83D59",
    strokeMiterlimit: 10,
    strokeWidth: 20,
    d: "m209.7 63.62-73.33 79.78m36.37 14.08c29.956 0 54.24-24.284 54.24-54.24S202.696 49 172.74 49s-54.24 24.284-54.24 54.24 24.284 54.24 54.24 54.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E39EAC",
    d: "M234.13 16.28H111.01c-4.462 0-8.08 3.616-8.08 8.075 0 4.46 3.618 8.075 8.08 8.075h123.12a8.07 8.07 0 0 0 7.464-4.984 8.06 8.06 0 0 0 0-6.182 8.08 8.08 0 0 0-7.464-4.984"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BA0C2F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M94.07 178.54h152.5m-152.5 12.53h59.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8ED07F",
    d: "M312.06 30.74a7.28 7.28 0 1 0 0-14.559 7.28 7.28 0 0 0 0 14.559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEDF4",
    d: "M278.5 22.1a72.2 72.2 0 0 0-21.61-4.57s-.21 8.36-.29 15c24 1.73 33.19 12.21 33.12 20.77l.13-15.3a17.44 17.44 0 0 0-11.35-15.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83D59",
    d: "M45.19 9.05a15.46 15.46 0 0 0 10.18 10.19 15.46 15.46 0 0 0-10.18 10.18A15.46 15.46 0 0 0 35 19.24 15.46 15.46 0 0 0 45.19 9.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0076A8",
    d: "M40.85 191.48c0 9.79 13.1 13.16 20.54 13.26 17.28.24 61 1 80.27-.28-60.75-6.27-83.2-12.65-93.7-17.65-5.08-2.42-7.12-5.41-7.12-8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0076A8",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "m199.26 142.96.05.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3391B9",
    d: "m47.802 135.179 31.965-11.771 6.314 17.479-26.879 11.557"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    d: "m84.434 123.087 10.513-3.593 3.145-6.562c.605-1.264 2.037-2.541 3.735-1.738s1.545 2.187.577 4.213l-.885 1.856s1.067-1.148 4.695.582 5.213 4.038 3.445 7.758l-4.379 9.186c-.687 1.434-2.523 3.782-7.673 1.311l-11.963 4.444-5.693-15.945z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E97537",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m104.141 123.121 5.332 2.598m-7.406 1.499 5.386 2.784m-7.492 1.324 5.697 2.888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA9B",
    stroke: "#E97537",
    strokeMiterlimit: 10,
    d: "M69.388 56.494s7.582 8.52 2.41 15.369c-4.033 5.351-12.425 2.095-12.425 2.095L56.579 71.6l-8.439-.53.661-11.386 12.653-7.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#614400",
    d: "M13.306 83.685c-1.725 1.733-1.402 4.553.328 6.28l11.803 11.793c1.008 1.007 3.034.242 3.718-1.008a7.5 7.5 0 0 1 2.717-2.823c3.995-2.48 6.123-1.113 7.668-7.156s1.99-7.552 7.593-9.853 5.687-5.581 5.687-5.581 6 2.34 6.225-1.618c0 0-1.015-2.585-2.922-3.01s-3.453-1.512-4.198-2.757c-.555-.927-.81-3.296 1.73-3.783s4.422 1.288 4.422 1.288 5.943-2.931 5.765-11.48c0 0 3.517 2.813 5.532 2.521l1.428 1.823c.2-.776.284-1.577.251-2.378-.025-1.546.566-4.003-2.864-6.892s-10.843-4.782-19.458-.105c-3.43 1.863-4.073 6.2-4.988 7.467s-1.737 4.08-6.732 5.97-5.308 6.6-5.809 8.544c-.5 1.943-.617 6.765-7.744 8.915-5.563 1.679-7.378 1.054-10.152 3.843"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#916500",
    d: "M64.84 63.688c.422-.113.586-.869.367-1.686-.219-.818-.739-1.39-1.161-1.277s-.587.868-.367 1.686.739 1.39 1.16 1.277m5.41-2.142c.367-.16.426-.833.134-1.503s-.826-1.084-1.193-.924c-.366.16-.427.832-.134 1.502s.827 1.084 1.193.925"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E97537",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m67.564 61.075 5.146 4.658-3.682 1.705m-3.317 3.175c.506-.174 1.771-.27 2.788.747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Forbidden_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h319v219H.5z"
  })))));
};
export default SvgForbidden;